<template>
    <div class="detail-item">
        <div class="type">
            <p>
                {{ `quote-results.static.policy_includes` | __ }}
            </p>
        </div>
        <div class="price flex">
            {{
                Object.keys(innerProps)
                    .map((key) => $trans(`quote-results.${type}.${key}`))
                    .join(", ")
            }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        innerProps: Object,
        type: String,
        currency: String
    },
};
</script>

<style lang="scss" scoped>
.detail-item {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
}
</style>
